<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    icon: {
      type: String,
      default: 'ion ion-help-circled',
    },
    tooltip: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    tooltipConf() {
      return {
        content: this.tooltip,
        placement: this.placement,
      };
    },
  },
});
</script>
<template>
  <i
    v-if="tooltip"
    v-tooltip="tooltipConf"
    :class="'cly-vue-tooltip-icon' + icon"
  />
</template>
